import watchdog from '@xl/watch-dog-jsutil';
import watchdogVuePlugin from '@xl/watch-dog-jsutil/lib/vue-plugin';
import ua from '@xl/user-agent';
import { GlobalUtil } from '@xl/js-utils';

// 测试 ua 识别的准确率
function testUserAgent() {
  const isAndroidApp = window.app?.webcall;
  const isIosApp = window.webkit?.messageHandlers?.app;
  const result = ua.parse();

  watchdog.sendEvent(
    isAndroidApp
      ? 'ua.parse.android'
      : isIosApp
        ? 'ua.parse.ios'
        : 'ua.parse.web',
    '' +
      (isAndroidApp ? result.isAndroid : isIosApp ? result.isIOS : result.isPC),
    '' + result.isInApp,
    '' + result.is_xl_driver_app,
    JSON.stringify(result),
  );
}

export default function(Vue) {
  // 初始化前端监控
  GlobalUtil.initWatchdog();

  // 为了捕获到 Vue 内部错误
  Vue.use(watchdogVuePlugin);

  // 测试 ua 识别的准确率
  setTimeout(() => testUserAgent(), 0);
}
